import { ProviderNote } from './notes/provider-note.types';
import { PagedFilter, GeoLocation } from '../common/common.types';
import { Product } from '../products/product.types';
import { MetaStatus } from '../meta/meta.types';
import { ProviderDeal } from './deals/provider-deal.types';

export class ProviderFilter extends PagedFilter {
	searchTerm?: string;
	statuses?: MetaStatus[];
}

export class ProviderSummary {
	providerId: number;
	status: MetaStatus;
	name: string;
	phone?: string;
	email?: string;
	website?: string;
	availability?: string;
	restrictions?: string;
	canRequestBooking?: boolean;
	summary?: string;
	location?: GeoLocation;
}

export class Provider {
	providerId: number;
	status: MetaStatus;
	name: string;
	contactName?: string;

	summary?: string;
	phone?: string;
	email?: string;
	website?: string;
	availability?: string;
	restrictions?: string;
	location?: GeoLocation;

	notes: ProviderNote[];
	products: Product[];
	deals: ProviderDeal[];
}

export interface NewProvider {
	name: string;
	contactName?: string;
	phone?: string;
	email?: string;
	website?: string;
	availability?: string;
	restrictions?: string;
	summary?: string;
	location?: GeoLocation;
}

export interface UpdatedProvider extends NewProvider {
	status: MetaStatus;
}
